import { Menu } from 'antd';
import style from './HomeBurgerMenu.module.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const items = [
  {
    key: '/',
    label: 'Home',
  },
  {
    key: 'Terms',
    label: 'Terms',
    children: [
      {
        key: '/info/terms-and-conditions',
        label: 'Terms',
      },
      {
        key: '/info/privacy-policy',
        label: 'Privacy Policy',
      },
      {
        key: '/info/refund-policy',
        label: 'Refund Policy',
      },
      {
        key: '/info/partnership',
        label: 'Partnership',
      },
    ],
  },
  {
    key: 'Services',
    label: 'Services',
    children: [
      {
        key: '/costs-and-prices',
        label: 'Costs and Prices',
      },
      {
        key: '/gift-delivering',
        label: 'Gift Delivering',
      },
      {
        key: '/live-chat-service',
        label: 'Live Chat',
      },
      {
        key: '/online-dating-service',
        label: 'Online dating',
      },
    ],
  },
  {
    key: '/info/contact-us',
    label: 'Contact Us',
  },
  {
    key: '/info/about-us',
    label: 'About Us',
  },
];
const HomeBurgerMenu = ({ close }) => {
  const navigate = useNavigate();
  const handleClick = ({ key }) => {
    navigate(key);
    close();
  };

  const handleSignUpClick = () => {
    navigate('/sign-up');
    close();
  };
  return (
    <div className={style.menuContainer}>
      <Menu
        onClick={handleClick}
        className={style.menu}
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        mode="inline"
        theme="dark"
        items={items}
      />
      <button className={style.signUpButton} onClick={handleSignUpClick}>
        Sign Up
      </button>
    </div>
  );
};

export default HomeBurgerMenu;
